module.exports = __webpack_public_path__ + "img/climate.cedda66e.svg";